import React, {useState} from 'react';
import { RxCross1 } from 'react-icons/rx';

const IpComponentWrap = () => {
    const [inputValue, setInputValue] = useState('');

    const [arrAdmin, setArrAdmin] = useState([
        {
            color: 'red',
            img: 'crown',
            name:'114.24.216.81'
        },
        {
            color: 'blue',
            img: 'bot',
            name:'124.129.106.245'
        },
        {
            color: 'purple',
            img: 'manager',
            name:'231.246.213.210'
        },
    ])

    const addNewRoleAmdin = () => {
        const newRole = {
            name: inputValue,
            color: '', 
            img: ''   
        };
        setArrAdmin(prev => [...prev, newRole]);
        setInputValue('');
    };

    const handleKeyPressAdmin = (e) => {
        if (inputValue && e.key === 'Enter') {
            addNewRoleAmdin();
        }
    };

    const deleteAdmin = (index) => {
        // Приклад видалення для arrAdmin
        setArrAdmin(prev => prev.filter((_, idx) => idx !== index));
    };
    return (
<div className='access_component_arr_user_wrap'>
                    {arrAdmin.map((item,idx) => (
                            <div key={idx} className='access_component_user_one'>
                                
                                <p>{item.name}</p>
                                <span 
                                    className='access_component_user_one_delete-icon' 
                                    onClick={() => deleteAdmin(idx)}
                                >
                                    <RxCross1/>
                                </span>
                            </div>
                    ))}
                    <input type="text" placeholder='...' value={inputValue} onChange={(e) => {setInputValue(e.target.value)}} onKeyPress={handleKeyPressAdmin}  />
                 </div>
    );
};

export default IpComponentWrap;